import { getErrorCodesFromException } from './useErrorCodes';

/** The API's code for "this request carried no usable session". */
export const UNAUTHENTICATED_ERROR_CODE = 'UNAUTHENTICATED';

export const DEFAULT_AUTH_ERROR_CODES = [
  UNAUTHENTICATED_ERROR_CODE,
  'FORBIDDEN',
];

/**
 * Whether a failure is the API saying the session is over.
 *
 * By the time a caller sees one of these, `HandleAuthErrorResponseLink` has
 * already signed the user out and the app is on its way to the login page, so
 * the operation did not fail for a reason the user can do anything about — it
 * belongs to a session that no longer exists. A caller can use this to stop
 * treating a sign-out in progress as a failure of its own (RWR-19755 / Sentry
 * PAYROLL-WEB-D-J5). Every other failure has to keep propagating so it stays
 * reportable.
 */
export function isSessionExpiredError(exception: unknown): boolean {
  return getErrorCodesFromException(exception).some((error) => {
    return error?.extensions?.code === UNAUTHENTICATED_ERROR_CODE;
  });
}
